<template>
  <h1>403</h1>
  <p>Доступ запрещен</p>
</template>
